import styled from "styled-components";

const HeaderContainer = styled.div`
	background-color: ${(props) => props.theme.colours.light_0};
	padding: 24px;
	margin-bottom: 24px;
`;

export default HeaderContainer;
